import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from './localStorage/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }


    /**
     * This function is used to get auth token.
     * @returns 
     */
    private getAuthToken(): string {
        return this.localStorageService.getAuthToken() || '';
    }

    /**
     * This function is used to get header.
     * @returns 
     */
    private getHeaders(): HttpHeaders {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'x-access-token': `${this.getAuthToken()}`, // If you need authorization token
            // Add other headers as needed
        });
        return headers;
    }

    /**
     * GET request
     * @param endpoint 
     * @returns 
     */
    get<T>(endpoint: string): Observable<T> {
        return this.http.get<T>(endpoint, { headers: this.getHeaders() }).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * POST request
     * @param endpoint 
     * @param body 
     * @returns 
     */
    post<T>(endpoint: string, body: any): Observable<T> {
        return this.http.post<T>(endpoint, body, { headers: this.getHeaders() }).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * PUT request
     * @param endpoint 
     * @param body 
     * @returns 
     */
    put<T>(endpoint: string, body: any): Observable<T> {
        return this.http.put<T>(endpoint, body, { headers: this.getHeaders() }).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * DELETE request
     * @param endpoint 
     * @returns 
     */
    delete<T>(endpoint: string): Observable<T> {
        return this.http.delete<T>(endpoint, { headers: this.getHeaders() }).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Handle errors from API calls
     * @param error 
     * @returns 
     */
    private handleError(error: HttpErrorResponse) {
        let errorMessage = {};
        if (error.error instanceof ErrorEvent) {
            // Client-side error
            console.log('client')
            errorMessage = `Error: ${error}`;
        } else {
            console.log('server')

            console.log(error)
            console.log(error.error.message)

            // Server-side error
            errorMessage = { errorCode: error.status, message: error.error.message };
        }
        return throwError(errorMessage);
    }
}
